function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n    .icon_contact {fill:none;stroke:currentColor;}\r\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  transform: "translate(0.84 0.84)"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon_contact",
  id: "Stroke_1",
  "data-name": "Stroke 1",
  d: "M0,26.067H27.259L11.117,0,.567,16.87",
  transform: "translate(18.741)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.68
}), /*#__PURE__*/React.createElement("path", {
  className: "icon_contact",
  id: "Stroke_3",
  "data-name": "Stroke 3",
  d: "M.5,0V7.667",
  transform: "translate(29.315 9.2)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.68
}), /*#__PURE__*/React.createElement("path", {
  className: "icon_contact",
  id: "Stroke_4",
  "data-name": "Stroke 4",
  d: "M.5.166V1.189",
  transform: "translate(29.315 21.555)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.68
}), /*#__PURE__*/React.createElement("path", {
  className: "icon_contact",
  id: "Stroke_5",
  "data-name": "Stroke 5",
  d: "M34.727,36.8C15.452,36.8,0,21.467,0,2.628A2.681,2.681,0,0,1,2.753,0H9.638a2.681,2.681,0,0,1,2.753,2.628,20.809,20.809,0,0,0,1.071,6.864,2.623,2.623,0,0,1-.612,2.628L8.873,16.064A29.534,29.534,0,0,0,21.111,28.038L25.089,24.1a2.469,2.469,0,0,1,2.753-.585,22.486,22.486,0,0,0,6.885,1.022,2.683,2.683,0,0,1,2.754,2.629v6.863a2.315,2.315,0,0,1-.918,1.9A2.216,2.216,0,0,1,34.727,36.8Z",
  transform: "translate(0 9.2)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.68
}));

var SvgIconContact = function SvgIconContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47.68,
    height: 47.68,
    viewBox: "0 0 47.68 47.68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-contact.beb05eeb.svg";
export { ForwardRef as ReactComponent };